<script lang="ts" setup>
import Table from '@/domains/investor/components/Table/Table.vue'
import type { DividendHistoryTableProps } from './DividendHistoryTable.types'

const props = defineProps<DividendHistoryTableProps>()
</script>

<template>
  <div class="dividend-history-table section-investor">
    <div class="section-investor__container">
      <h3 class="dividend-history-table__title">
        {{ table.title }}
      </h3>

      <div class="dividend-history-table__wrapper">
        <Table
          :table="props.table"
          :options="props.options"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.dividend-history-table {
  &__title {
    @include h7;
    margin-bottom: 6.4rem;
    color: $text-400;
    text-align: center;
  }
    
  @include atXS {
    &__title {
      @include h5;
    }
  }
}
</style>
